
import { Navigate } from "react-router-dom"


export const AuthProtectedRoute = ({ children }) => {
    const values = localStorage.getItem('clinic')
    if (values && values !== "") {
        return children
    } else {
        return <Navigate to="/" />
    }
}